import { css } from 'linaria';

export const constructionHousesAdviceSwiper = css`
  padding: 15px;
  margin: -15px;
`;

export const constructionHousesAdviceSlide = css`
  && {
    width: 377px;
    height: unset;
    margin-right: 24px;

    :last-of-type {
      margin-right: 0;
    }

    @media (--only-desktop) {
      width: 297px;
    }

    @media (--only-tablet) {
      width: 209px;
      margin-right: 16px;
    }

    @media (--only-mobile) {
      width: 204px;
      margin-right: 16px;
    }

    && a {
      height: 100%;
      border-radius: var(--rounding-l);
    }
  }
`;

export const constructionHousesAdviceImage = css`
  height: 262px;

  @media (--only-desktop) {
    height: 204px;
  }

  @media (--to-desktop) {
    height: 156px;
  }
`;

export const constructionHousesAdviceContent = css`
  padding: 24px;

  @media (--to-desktop) {
    padding: 24px 16px;
  }
`;

export const constructionHousesAdviceName = css`
  && {
    @media (--from-desktop) {
      width: 230px;
    }
  }
`;
